import { format } from "date-fns";

//Formats ISO date to MM/dd/yyyy HH:mm:ss
export const formatDateTime = (time: string) => {
  const formattedDateTime = format(new Date(time), "MM/dd/yyyy HH:mm:ss");
  return formattedDateTime;
};

export const capitalizeWord = (word: string) => {
  return word.charAt(0).toUpperCase() + word.slice(1);
};

//CHARACTER VALIDATION METHODS//
export const isValidInput = (inputLabel: string) => {
  const regex = /[^0-9A-Za-z.\-_~]/;
  if (!regex.test(inputLabel) === false) return true;
  else return false;
};

export const isInvalidStartingOrEndingChar = (inputLabel: string) => {
  const regexStartWithCharNum = /^[A-Za-z0-9]/;
  const regexEndWithCharNum = /[A-Za-z0-9]$/;
  if (
    regexStartWithCharNum.test(inputLabel) === false ||
    regexEndWithCharNum.test(inputLabel) === false
  )
    return true;
  else return false;
};

export const isConsecutiveSymbols = (inputLabel: string) => {
  const invalidRepeatArray = [
    "..",
    "--",
    "__",
    ",,",
    ".-",
    "-.",
    "._",
    "_.",
    ".,",
    ",.",
    "-_",
    "_-",
    "-,",
    ",-",
    "_,",
    ",_",
  ];
  if (invalidRepeatArray.some((el) => inputLabel.includes(el))) return true;
  else return false;
};

export const toAbsoluteUrl = (pathname: string) =>
  process.env.PUBLIC_URL + pathname;

export const getAppEnvironment = () => {
  let environment = "localhost";
  if (window.location.origin.includes("ascalon.ai")) {
      environment = "development";
  } else if (window.location.origin.includes("voicegain.ai")) {
      environment = "production";
  } else if (window.location.origin.includes("voicegain.xyz")) {
      environment = "QA";
  }
  return environment;
};

